module.exports = __webpack_public_path__ + "static/img/6.9b84df7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/10/zh/6.png
// module id = 5wIR
// module chunks = 0